import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const tablesRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.tables.root,
    lazyImport: () => import('../../domains/protected/tables/TablesRoute.tsx'),
    requiresAuth: true,
    resourceId: 'table-item',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/tables/pages/tables-list/TablesListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.tables.details,
        lazyImport: () =>
          import('../../domains/protected/tables/pages/table-details/TableDetailsRoute.tsx'),
        resourceId: 'table-item',
        children: [
          {
            index: true,
            lazyImport: () =>
              import('../../domains/protected/tables/pages/table-details/TableDetails.tsx'),
            nav: {
              backTo: routesPaths.tables.root,
              breadcrumbKey: 'details'
            }
          },
          {
            path: 'items',
            lazyImport: () => import('../../domains/protected/tables/pages/items/RedirectRoute.tsx')
          },
          {
            path: 'items/:itemId',
            lazyImport: () =>
              import('../../domains/protected/tables/pages/item-details/ItemDetailsRoute.tsx'),
            nav: {
              backTo: routesPaths.tables.details(':id'),
              breadcrumbKey: 'itemDetails'
            }
          },
          {
            path: 'items/new',
            lazyImport: () =>
              import('../../domains/protected/tables/pages/item-details/ItemDetailsRoute.tsx'),
            nav: {
              backTo: routesPaths.tables.details(':id'),
              breadcrumbKey: 'newItem'
            }
          }
        ]
      }
    ]
  }
];
